/* RumPumBumm site script (2026-09-28): the approved prototype's behaviour (design/app-v2.js)
   on the live store. Dialogs (phone menu, search, wishlist), live product search, the product
   rails' arrows, Add to Cart buttons that hand over to Dawn's cart drawer, and the toast.
   Markup comes from the rpb-* sections and snippets; styles from assets/rpb-site.css. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  // Prices follow Settings > General > Currency formatting (theme.liquid -> rpbMoneyFormat), trailing ".00" dropped.
  const money = window.rpbMoney = (paise) => {
    const n = Number(paise) / 100, whole = Number.isInteger(n);
    const fmt = (v, d, loc) => v.toLocaleString(loc, { minimumFractionDigits: d, maximumFractionDigits: d });
    return (window.rpbMoneyFormat || '₹{{amount_no_decimals}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      const eu = /comma/.test(k), d = /no_decimals/.test(k) || whole ? 0 : 2;
      if (/apostrophe/.test(k)) return fmt(n, d, 'de-CH');
      if (/space/.test(k)) return fmt(n, d, 'fr-FR');
      return fmt(n, d, eu ? 'de-DE' : 'en-US');
    });
  };
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Toast (prototype notify()).
  let toastTimer;
  function notify(message) {
    const toast = $('.rpb-toast .toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('visible'), 2800);
  }
  window.rpbNotify = notify;

  // Dialogs: [data-rpb-open="id"] opens one (closing any other), [data-rpb-close] closes its
  // own; a click on the backdrop closes, Escape is native.
  function openDialog(id, opener) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    $$('dialog[open]').forEach((open) => open !== dialog && open.close());
    if (!dialog.open) dialog.showModal();
    dialog.dispatchEvent(new CustomEvent('rpb:open', { detail: { opener } }));
    const field = $('input[type=search]', dialog);
    if (field) field.focus();
  }
  window.rpbOpenDialog = openDialog;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-rpb-open]');
    if (opener) { event.preventDefault(); openDialog(opener.dataset.rpbOpen, opener); return; }
    const closer = event.target.closest('[data-rpb-close]');
    if (closer) { const dialog = closer.closest('dialog'); if (dialog) dialog.close(); return; }
    const toaster = event.target.closest('[data-rpb-toast]');
    if (toaster) { if (toaster.matches('a[href^="#"]')) event.preventDefault(); notify(toaster.dataset.rpbToast); }
  });

  // Featured sets (prototype pickSetColour): a colour dot swaps the photo and points the button
  // at that colour; the section renders each dot's photo and link.
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-set-colour]');
    if (!swatch) return;
    const card = swatch.closest('.set-feature');
    const photo = $('.set-photo img', card);
    if (photo && swatch.dataset.src) { photo.removeAttribute('srcset'); photo.src = swatch.dataset.src; photo.alt = swatch.dataset.alt || ''; }
    const label = $('.set-colours span', card);
    if (label) label.textContent = swatch.dataset.setColour;
    $$('.set-swatch', card).forEach((other) => other.setAttribute('aria-pressed', String(other === swatch)));
    if (swatch.dataset.href) $$('a.pill, a.set-link', card).forEach((link) => { link.href = swatch.dataset.href; });
  });
  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });

  // Add to Cart: Dawn's cart drawer takes over (the same hand-off as Dawn's product form).
  async function addToCart(items, button) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await response.json();
      if (!response.ok) throw data;
      $$('dialog[open]').forEach((dialog) => dialog.close());
      if (drawer && drawer.renderContents) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = root() + 'cart';
      }
      return data;
    } catch (error) {
      notify((error && (error.description || error.message)) || 'Sorry, that could not be added. Please try again.');
      throw error;
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label; }
    }
  }
  window.rpbAddToCart = addToCart;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rpb-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    addToCart([{ id: Number(button.dataset.rpbAdd), quantity: 1 }], button).catch(() => {});
  });

  // Product rails (prototype syncRail): native scroll with snap; the arrows step one card and
  // disable at either end. The rail scrolls itself, never the page.
  function syncRail(track) {
    const rail = track.closest('.rail');
    if (!rail) return;
    const max = track.scrollWidth - track.clientWidth;
    rail.classList.toggle('is-static', max <= 1);
    const prev = $('[data-rail-step="-1"]', rail), next = $('[data-rail-step="1"]', rail);
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;
  }
  const railResize = new ResizeObserver((entries) => entries.forEach((entry) => syncRail(entry.target)));
  function initRails(scope = document) {
    $$('.rail-track', scope).forEach((track) => {
      if (track.dataset.rpbRail) return;
      track.dataset.rpbRail = '1';
      railResize.observe(track);
      track.addEventListener('scroll', () => syncRail(track), { passive: true });
      syncRail(track);
    });
  }
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-rail-step]');
    if (!arrow) return;
    const track = $('.rail-track', arrow.closest('.rail'));
    const first = track && track.firstElementChild;
    if (first) track.scrollBy({ left: (first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0)) * Number(arrow.dataset.railStep), behavior: 'smooth' });
  });

  // Search (prototype searchProducts): Shopify's predictive search, results in the prototype's rows.
  function searchRow(product) {
    const variant = (product.variants || []).find((v) => v.available) || (product.variants || [])[0] || {};
    const isSet = /bundle/i.test(product.type || '');
    const price = Number(String(variant.price ?? product.price).replace(/[^\d.]/g, '')) * (String(variant.price ?? product.price).includes('.') ? 100 : 1);
    const compareRaw = variant.compare_at_price ?? product.compare_at_price_max;
    const compare = compareRaw ? Number(String(compareRaw).replace(/[^\d.]/g, '')) * (String(compareRaw).includes('.') ? 100 : 1) : 0;
    const now = `<strong${compare > price ? ' class="deal"' : ''}>${money(price)}</strong>`;
    const priceHTML = compare > price ? `${now}<del><span class="sr-only">MRP </span>${money(compare)}</del>` : now;
    const image = (variant.featured_image && variant.featured_image.url) || product.featured_image?.url || product.image || '';
    const alt = (variant.featured_image && variant.featured_image.alt) || product.featured_image?.alt || '';
    const action = isSet || !variant.id
      ? `<a class="pill" href="${esc(product.url)}">View set</a>`
      : `<button class="pill" type="button" data-rpb-add="${variant.id}" aria-label="Add +: ${esc(product.title)}">Add +</button>`;
    return `<article class="search-item">${image ? `<img src="${esc(image)}${image.includes('?') ? '&' : '?'}width=160" alt="${esc(alt)}" width="80" height="80" loading="lazy">` : ''}<div><h3><a href="${esc(product.url)}">${esc(product.title)}</a></h3><p class="price">${priceHTML}</p></div>${action}</article>`;
  }
  function initSearch() {
    const dialog = document.getElementById('rpb-search');
    if (!dialog) return;
    const input = $('input[type=search]', dialog);
    const results = $('[data-rpb-search-results]', dialog);
    const initial = ($('template[data-rpb-search-default]', dialog) || {}).innerHTML || '';
    const fill = () => { if (!input.value.trim() && !results.children.length) results.innerHTML = initial; };
    document.addEventListener('click', (event) => { if (event.target.closest('[data-rpb-open="rpb-search"]')) fill(); });
    input.addEventListener('focus', fill);
    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        const query = input.value.trim();
        if (!query) { results.innerHTML = initial; return; }
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${root()}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
          const data = await (await fetch(url, { signal: controller.signal })).json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          results.innerHTML = products.length ? products.map(searchRow).join('') : `<p>${esc(dialog.dataset.empty)}</p>`;
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = `<p>${esc(dialog.dataset.empty)}</p>`;
        }
      }, 180);
    });
  }

  // Wishlist (prototype renderWishlist, in its dialog): saved items stay in this browser under
  // 'rpb-wishlist', in the same shape the September wishlist used ({h, t, p, c, i, v}).
  const WISH_KEY = 'rpb-wishlist';
  const readWish = () => {
    try { const list = JSON.parse(localStorage.getItem(WISH_KEY)); return Array.isArray(list) ? list.filter((x) => x && /^[a-z0-9-]+$/.test(x.h)) : []; }
    catch { return []; }
  };
  const paise = (value) => {
    if (value === '' || value == null) return 0;
    if (typeof value === 'number') return value;
    const text = String(value).replace(/[^\d.]/g, '');
    return text.includes('.') ? Math.round(Number(text) * 100) : Number(text);
  };
  function paintWish() {
    const list = readWish(), saved = list.map((x) => x.h);
    $$('[data-rpb-wl]').forEach((button) => button.setAttribute('aria-pressed', String(saved.includes(button.dataset.handle))));
    $$('.wish-count').forEach((count) => { count.textContent = list.length; count.hidden = !list.length; });
    $$('.wish-button').forEach((button) => button.setAttribute('aria-label', `Open wishlist, ${list.length} saved`));
    const items = document.getElementById('rpb-wish-items');
    if (!items) return;
    items.innerHTML = list.length ? list.map((x) => {
      const now = paise(x.p), was = paise(x.c);
      const price = was > now ? `<strong class="deal">${money(now)}</strong><del><span class="sr-only">MRP </span>${money(was)}</del>` : `<strong>${money(now)}</strong>`;
      return `<article class="search-item">${x.i ? `<img src="${esc(x.i)}" alt="" width="80" height="80" loading="lazy">` : ''}<div><h3><a href="${root()}products/${esc(x.h)}">${esc(x.t)}</a></h3><p class="price">${price}</p></div><button class="pill" type="button" data-rpb-unwish="${esc(x.h)}" aria-label="Remove ${esc(x.t)} from your wishlist">Remove</button></article>`;
    }).join('') : `<div class="empty-cart"><h3>Nothing saved yet.</h3><p>Tap the heart on any product to save it here.</p></div>`;
  }
  window.rpbPaintWish = paintWish;
  function writeWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch {} paintWish(); }
  async function refreshWish() {
    const list = readWish();
    const fresh = await Promise.all(list.map((x) => fetch(`${root()}products/${x.h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    let changed = false;
    fresh.forEach((product, n) => {
      if (!product) return;
      const variant = product.variants.find((v) => String(v.id) === String(list[n].v) && v.available) || product.variants.find((v) => v.available) || product.variants[0];
      const next = { ...list[n], t: product.title, p: variant.price, c: variant.compare_at_price > variant.price ? variant.compare_at_price : '', v: variant.id };
      if (JSON.stringify(next) !== JSON.stringify(list[n])) { list[n] = next; changed = true; }
    });
    if (changed) writeWish(list);
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rpb-wl-toggle]')) { event.preventDefault(); openDialog('rpb-wish'); refreshWish(); return; }
    const remove = event.target.closest('[data-rpb-unwish]');
    if (remove) { const h = remove.dataset.rpbUnwish; const item = readWish().find((x) => x.h === h); writeWish(readWish().filter((x) => x.h !== h)); if (item) notify(`${item.t} removed from your wishlist`); return; }
    const heart = event.target.closest('[data-rpb-wl]');
    if (!heart) return;
    event.preventDefault();
    const h = heart.dataset.handle, list = readWish(), saved = list.some((x) => x.h === h);
    const title = heart.dataset.title;
    writeWish(saved ? list.filter((x) => x.h !== h) : [{ h, t: title, p: Number(heart.dataset.price) || heart.dataset.price, c: heart.dataset.compare ? Number(heart.dataset.compare) : '', i: heart.dataset.image, v: heart.dataset.variant }, ...list]);
    notify(`${title} ${saved ? 'removed from' : 'saved to'} your wishlist`);
  });
  window.addEventListener('storage', (event) => { if (event.key === WISH_KEY) paintWish(); });

  // Cart set suggestion (prototype setSwap): a plate or bowl, a bib and a spoon & fork bought
  // separately in one colour cost more than the matching set, so Dawn's cart drawer offers the
  // swap. Sets and their pieces: Theme settings > RumPumBumm (snippets/rpb-cart-swap-data).
  const SWAP = (() => { try { return JSON.parse(document.getElementById('rpb-swap-data').textContent); } catch { return []; } })();
  const colourOf = (line) => ((line.options_with_values || []).find((o) => /colou?r/i.test(o.name)) || {}).value;
  async function findSwap() {
    if (!SWAP.length) return null;
    const cart = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    for (const set of SWAP) {
      const colours = [...new Set(cart.items.map(colourOf).filter(Boolean))];
      for (const colour of colours) {
        const lines = set.types.map((type) => cart.items.find((line) => line.product_type === type && colourOf(line) === colour));
        if (lines.some((line) => !line)) continue;
        const plate = set.design ? lines.find((line) => /plate/i.test(line.product_type)) : null;
        const design = plate ? plate.product_title.split(' ')[0] : null;
        const target = set.variants.find((v) => v.available && v.options.includes(colour) && (!design || v.options.includes(design)));
        if (!target) continue;
        const now = lines.reduce((sum, line) => sum + line.final_line_price / line.quantity, 0);
        if (now - target.price >= 100) return { set, target, lines, saving: now - target.price };
      }
    }
    return null;
  }
  let swapTimer, swapBusy = false;
  async function paintSwap() {
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || swapBusy) return;
    const swap = await findSwap().catch(() => null);
    const old = footer.querySelector('.rpb-swap');
    if (old) old.remove();
    if (!swap) return;
    const box = document.createElement('div');
    box.className = 'rpb-section rpb-free rpb-swap';
    box.innerHTML = `<div class="cart-swap"><p>These pieces make our <strong>${esc(swap.set.title)}</strong> set. Swap to the set and save ${money(swap.saving)}.</p><button class="pill" type="button" data-rpb-swap>Swap to ${esc(swap.set.title)}</button></div>`;
    box._swap = swap;
    footer.prepend(box);
  }
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rpb-swap]');
    if (!button) return;
    const swap = button.closest('.rpb-swap')._swap;
    button.disabled = true;
    swapBusy = true;
    try {
      const updates = Object.fromEntries(swap.lines.map((line) => [line.key, line.quantity - 1]));
      await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      swapBusy = false;
      await addToCart([{ id: swap.target.id, quantity: 1 }]);
      notify(`Swapped to the ${swap.set.title} set · saved ${money(swap.saving)}`);
    } catch { swapBusy = false; button.disabled = false; }
  });
  function watchCart() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !SWAP.length) return;
    new MutationObserver((records) => {
      if (records.every((record) => record.target.closest && record.target.closest('.rpb-swap'))) return;
      if (records.every((record) => [...record.addedNodes].every((node) => node.classList && node.classList.contains('rpb-swap')))) return;
      clearTimeout(swapTimer);
      swapTimer = setTimeout(paintSwap, 150);
    }).observe(drawer, { childList: true, subtree: true });
    paintSwap();
  }

  // Free shipping bar (snippets/rpb-ship-bar): Dawn swaps the drawer's HTML on every cart change, which would make
  // the bar jump. It grows instead: from empty each time the drawer opens, from where it was when the cart changes
  // while open; crossing the goal plays the unlock (.is-new: pop, van hop, dots). Reduced motion: no animation.
  function watchShip() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let seen = 0, open = drawer.classList.contains('active');
    const grow = (from, wait = 40) => {
      const bar = drawer.querySelector('.rpb-ship');
      if (!bar) { seen = 0; return; }
      bar.dataset.grown = '1';
      const to = Number(bar.dataset.pct) || 0, unlocked = to >= 100 && seen < 100;
      seen = to;
      if (still) return;
      bar.style.setProperty('--pct', `${from}%`);
      bar.getBoundingClientRect();
      setTimeout(() => bar.style.setProperty('--pct', `${to}%`), wait);
      if (unlocked) setTimeout(() => bar.classList.add('is-new'), wait + 750);
    };
    new MutationObserver(() => {
      const now = drawer.classList.contains('active');
      if (now && !open) grow(0, 320);  // after the drawer slides in
      open = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(() => {
      const bar = drawer.querySelector('.rpb-ship');
      if (bar && !bar.dataset.grown && open) grow(seen);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    watchCart();
    watchShip();
    initRails();
    initSearch();
    paintWish();
  }
  document.addEventListener('shopify:section:load', (event) => { initRails(event.target); paintWish(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
